export default {
  pickup: 'Odbiór',
  delivery: 'Dostawa',
  ongoing_order: 'Trwające zamówienie',
  view_more: 'Dotknij, aby zobaczyć szczegóły',
  status: {
    rejected: {
      title: 'Zamówienie odrzucone',
      description: 'Dotknij, aby zobaczyć szczegóły',
    },
    created: {
      description: 'Zamówienie otrzymane',
    },
    reviewed: {
      description: 'Twoje zamówienie zostało zauważone',
    },
  },
  order_type: {
    pickup: 'odbiór',
    delivery: 'dostawa',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Twoje zamówienie zostało zauważone',
    order_confirmed: '#{{number}} Potwierdzono na {{time}}',
    order_preparation_up_time_changed: '#{{number}} Czas {{type}} zmieniony na {{time}}',
    order_preparing: 'Twoje zamówienie #{{number}} jest przygotowywane',
    order_rejected: 'Zamówienie #{{number}} odrzucone',
  },
  error_messages: {
    failed_to_load: 'Coś poszło nie tak, spróbuj ponownie.',
  },
};
